/* eslint-disable semi-spacing */
import { formatFileSize, formatDateTimeStrByTimestamp } from '@gp/utils/common';
import { formatPlatformsReq, formatEngineRes, formatengineOptionalRes } from '@gp/utils/renderers';
import type { IProjectInformationDTO } from '@gp/types/projectDetail';
import type { IStudioDTO } from '@gp/pages/Workspace/Product/types';
import { isEmpty } from 'lodash';

export const formatStudios = (studios?: IStudioDTO[]): IStudioDTO[] => {
  if (!Array.isArray(studios) || !studios.length) return [];
  return studios
    .filter((studio) => {
      const { id, name } = studio || {};
      return !!id && !!name;
    })
    .sort((a, b) => {
      const nameA = a?.name?.toUpperCase() || '';
      const nameB = b?.name?.toUpperCase() || '';
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
};

export const formatCondOptionByKey = (filterList: any, keyName: string): IStudioDTO[] => {
  if (isEmpty(filterList)) return [];
  const platformList = filterList?.[keyName] || [];
  return platformList?.map((item: string) => {
    return {
      text: item,
      value: item,
    };
  });
};

export const getParams = (payload: any): any => {
  const {
    project,
    cover,
    name: coverName,
    file_size: coverSize,
    timestamp: coverTimestamp,
    stage,
    platform,
    studio_entity_id: studioEntityId,
    publisher,
    business_model: businessModel,
    ip,
    genre,
    engine,
    engineOptional = [],
    pro_coa,
    pro_coa_id,
    studio_location,
  } = payload;

  return {
    project: project?.trim() || '',
    cover,
    image_name: coverName || '',
    image_size: formatFileSize(coverSize) || '',
    upload_day: formatDateTimeStrByTimestamp(coverTimestamp, '') || '',
    stage,
    // platform: platformFormatted,
    platform,
    studio_entity_id: studioEntityId,
    studio_location,
    coa: pro_coa,
    coa_id: pro_coa_id,
    // studio: studio?.name || '',
    // priority: priorityFormatted,
    // form: parent,
    // sub_form: child,
    // form_2: form2,
    publisher: publisher?.trim() || '',
    business_model: (businessModel as string[])?.join(';') || '',
    ip,
    genre,
    engine: formatEngineRes(engine, engineOptional) || [],
    engine_optional: formatengineOptionalRes(engineOptional) || [],
    // engine: formatEngineRes(engine, engineOptional),
    // engine_optional: formatengineOptionalRes(engineOptional),
  };
};

export const formatEngineOptionalRes = (engineOptions?: any): any => {
  if (!Array.isArray(engineOptions) || !engineOptions.length) return [];
  const arrengine = engineOptions?.map((subItem: any) => {
    return { id: subItem.value, tag: subItem.text };
  });
  return arrengine || [];
};

export const formatEngineOptionsRes = (engineOptions?: any): any => {
  if (!Array.isArray(engineOptions) || !engineOptions.length) return [];
  const arrengine = engineOptions?.map((subItem: any) => {
    return { value: subItem.value, text: subItem.text, is_public: subItem?.data?.is_public };
  });
  return arrengine || [];
};
